import PropTypes from 'prop-types';
import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import ImpactAssessmentsPageContainer from './_ImpactAssessmentsPageContainer';
import BasicDetailContainer from '../_Common/BasicDetailContainer';

const ImpactAssessments = ({ children, ...otherProps }) => (
  <Grid fluid>
    <Row>
      <Col md={3}>
        <ImpactAssessmentsPageContainer {...otherProps} />
      </Col>
      <Col md={9}>
        <BasicDetailContainer>{children}</BasicDetailContainer>
      </Col>
    </Row>
  </Grid>
);

ImpactAssessments.propTypes = {
  children: PropTypes.node,
};

export default ImpactAssessments;
